import ImageSelect2 from "component/ImageSelect2";
import {BaseModule} from "system/modules/BaseModule";
import PromiseHandler from "system/api/PromiseHandler";

export default class LanguageSelectModule
   extends BaseModule
{

   onReady() {
      const body = document.body;
      const langSelector = body.querySelector('.js-select-language');

      if (!langSelector)
         return;


      (new ImageSelect2(langSelector))
         .getInstance()
         .on('change', async function (event: Event) {
            if (!event.target || !(event.target instanceof HTMLSelectElement))
               return;

            const jazykID = event.target.value;

            window.splashLoader.enable();
            event.target.closest('.dropdown-menu')?.classList.remove('show');

            (new PromiseHandler()).post(
               '/environment-changelang',
               {
                  id_jazyk: jazykID
               }
            ).then((result) => {
               location.reload();
            });

            // ApiClient.fetch<{ success: boolean }>(
            //    '/environment-changelang',
            //    {
            //       body: {
            //          id_jazyk: jazykID
            //       }
            //    }
            // ).then((result) => {
            //    location.reload();
            // });
         });
   }
}